import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';

import AutoResizeTextarea from '../components/customFields/autoResizeTextarea';
import CustomSelect from '../components/customFields/customSelect';

import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';

import GeneralForm from '../components/generalForm';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setMarketplace } from './marketplacesActions';
import icon from '../assets/icons/form-item.svg';
import RichText from '../components/customFields/richText';
import ItemMarketplaces from '../components/customFields/itemMarketplaces';
import PriceFields from '../components/customFields/priceFields';
import forms from '../utils/forms';
import NutritionalInfoFields from '../components/customFields/nutritionalInfoFields';
import MultiSelect from '../components/customFields/multiSelect';
import { useItemFirstLevelCategories } from './apiHooks';

const MarketplaceAdminItemForm = ({ currentUser, match, history, intl, marketplace, action }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [item, setItem] = useState(forms.getFormObjectFromItem(null, marketplace));

  const [marketplacesLoading, setMarketplacesLoading] = useState(false);
  const [marketplacesError, setMarketplacesError] = useState(null);
  const [marketplaces, setMarketplaces] = useState([]);

  const { categories } = useItemFirstLevelCategories({ showHiddenSecondLevelCategories: true });

  useEffect(() => {
    if (action === 'edit') {
      setError(null);
      setLoading(true);
      apiCalls
        .getItems({
          itemId: match.params.itemId,
        })
        .then((result) => {
          setItem(forms.getFormObjectFromItem(result.data.items[0]));
          setImages(result.data.items[0].images);
          setLoading(false);
          getMarketplaces();
        })
        .catch((errors) => {
          console.log({ errors });
          setError(utils.getErrorMessageFromResponse(errors));
          setLoading(false);
        });
    } else {
      getMarketplaces();
    }
  }, [match.params.itemId]);

  function getMarketplaces() {
    setMarketplacesError(null);
    setMarketplacesLoading(true);
    apiCalls
      .getMarketplaces({
        userId: currentUser.id,
      })
      .then((result) => {
        setMarketplaces(result.data.marketplaces);
        setMarketplacesLoading(false);
      })
      .catch((errors) => {
        setMarketplacesError(utils.getErrorMessageFromResponse(errors));
        setMarketplacesLoading(false);
      });
  }

  const itemForm = forms.getItemForm(
    forms.getServerItemFromFormObject(item), // do all non-form operations with correct item format
    utils.userIsAdmin(currentUser),
    marketplaces,
    intl,
    categories
  );

  function onFormSubmit() {
    setLoading(true);

    if (action === 'edit') {
      return apiCalls
        .editItem({ item: forms.getServerItemFromFormObject(item), images: images })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: `/marketplaceAdmin/${marketplace.id}/view`,
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    } else {
      return apiCalls
        .createItem({ item: forms.getServerItemFromFormObject(item), images: images })
        .then((result) => {
          setLoading(false);
          history.push({
            pathname: `/marketplaceAdmin/${marketplace.id}/view`,
          });
        })
        .catch((error) => {
          setLoading(false);
          setError(utils.getErrorMessageFromResponse(error, true));
          window.scrollTo(0, 0);
        });
    }
  }

  const formFields = {
    autoResizeTextarea: AutoResizeTextarea,
    customSelect: CustomSelect,
    multiSelect: MultiSelect,
    richText: RichText,
    itemMarketplaces: ItemMarketplaces,
    priceFields: PriceFields,
    nutritionalInfoFields: NutritionalInfoFields,
  };

  const { formatMessage } = useIntl();

  return (
    <div className="row">
      <div className="col-12 col-lg-10 offset-lg-1 marketplace-admin__form">
        {item ? (
          <GeneralForm
            title={
              action === 'edit'
                ? intl.formatMessage({ id: 'item.edit.header' }, { itemName: utils.getItemName(item, formatMessage) })
                : intl.formatMessage({ id: 'item.create.header' })
            }
            icon={icon}
            onChange={(event) => setItem(event.formData)}
            onSubmit={onFormSubmit}
            uploadImage={(image) => apiCalls.uploadImage(image, 'item', item.id)}
            deleteImage={(image) => apiCalls.deleteImage(image)}
            onImagesChange={(images) => setImages(images)}
            formSchema={itemForm.schema}
            formUiSchema={itemForm.uiSchema}
            formFields={formFields}
            formData={item}
            uploadedImages={images}
            buttonCopy={'item.edit.form.submit'}
            errorMessage={error || marketplacesError}
            loading={loading || marketplacesLoading}
            singleImage={false}
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

MarketplaceAdminItemForm.propTypes = {
  action: PropTypes.string.isRequired,
  currentUser: PropTypes.object,
  marketplace: PropTypes.object,
};

MarketplaceAdminItemForm.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
    marketplace: state.marketplace.marketplace,
  };
}

const mapDispatchToProps = {
  setMarketplace,
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(MarketplaceAdminItemForm)));
